export const environment = {
  production: false,
  useMockData: true,
  apiUrl: 'https://api-gateway.tegalhub.com/api-passport-medical/v1/front',
  refUrl: 'https://referential-pro-back.tegalhub.com',
  uploadApiUrl: 'https://passport-back.preprod.tegalhub.com/passeport/documents/upload',
  appName: 'Dossier Patient Partagé',
  version: '1.0.0',

  // Configuration du thème
  theme: {
    default: 'dpp', // 'eyone' ou 'dpp'
  },

  // Configuration des timeouts
  httpTimeout: 45000, // 45 secondes en préproduction

  // Configuration des retry
  maxRetries: 3,
  retryDelay: 1500, // 1.5 seconde

  // Configuration des logs
  enableLogs: true,
  logLevel: 'info',

  // Configuration de l'authentification
  auth: {
    tokenKey: 'passeport_token',
    refreshTokenKey: 'passeport_refresh_token',
    tokenExpiryKey: 'passeport_token_expiry',
    autoRefresh: true,
    refreshThreshold: 5 * 60 * 1000, // 5 minutes avant expiration
  },

  // Configuration des uploads
  upload: {
    maxFileSize: 15 * 1024 * 1024, // 15MB en préproduction
    allowedTypes: [
      'image/*',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    maxFiles: 8,
  },

  // Configuration des notifications
  notifications: {
    position: 'top-right',
    duration: 4000,
    enableSound: false,
  },

  // Configuration des features
  features: {
    enableOfflineMode: false,
    enablePushNotifications: false,
    enableAnalytics: true,
  },

  // Configuration OneSignal Web Push
  oneSignal: {
    appId: '',
    safariWebId: '',
    serviceWorkerPath: 'OneSignalSDKWorker.js',
    serviceWorkerUpdaterPath: 'OneSignalSDKUpdaterWorker.js',
    sdkUrl: 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js',
    allowLocalhostAsSecureOrigin: true,
  },

  // Configuration Google Maps
  googleMaps: {
    apiKey: 'AIzaSyDbOznBcfBFHISn0i381WED65meKHTRlhg',
    defaultZoom: 15,
    defaultHeight: '200px',
  },
  paymentToken: 'test_public-52ea4aba-8343-4362-87b4-cba7aeb54731.F9zzFQmHyVEyDv9sGfxwJWXEScwGDIccKSBpKZuyDIobK1YAnAsUUVMFmDhiYClc',

  appStoreUrl: 'https://apps.apple.com/sn/app/eyone-passeport-medical/id1631393669',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.passeportsante.eyone',
};
